(ns storrito.editor.background
  "Background util functions"
  (:require [storrito.instagram.story.editor.dimension :as dimension]))

(defn background-color-rect
  "Creates fabricjs Rect background object.
  Takes a map with keys :fill (bg color) and optional :margin"
  [{:keys [fill margin]}]
  (let [{:keys [image/height image/width margin/top margin/left]} (dimension/dimensions dimension/story-image)]
    (js/fabric.Rect.
      (clj->js
        {:fill fill
         :width width
         :height height
         :top (if (= margin 0) 0 top)
         :left (if (= margin 0) 0 left)
         :id "background"
         :selectable false}))))